import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';
import useToast from 'services/Hooks/useToast';

export const useCreateShowroomProjectRequest = () => {
  const { saveMessage, errorMessage } = useToast();

  return useMutation({
    mutationFn: async ({ request, files }) => {
      const response = await axios.post(`${HOST}/api/dealer-portal/showroom-project-requests`, request);

      if (files?.length) {
        for (const file of files) {
          const formData = new FormData();
          formData.append('files', file);
          await axios.post(
            `${HOST}/api/dashboard/attached-files/${response.data.id}?type=${BlobStorageTypeEnumValue.ShowroomProjectRequest}`,
            formData,
          );
        }
      }

      return response.data;
    },
    onSuccess: saveMessage,
    onError: errorMessage,
  });
};
